import { useEffect } from "react";

// the park's one real production domain — canonical/og URLs must always point
// here, whichever host (preview, emergent.host) the visitor happens to browse
export const SITE_URL = "https://coolrunnings.capetown";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function setPageMeta({ title, description, keywords, image, noindex } = {}) {
  // canonical URL for this route on the production domain (never the browsing host)
  const path = window.location.pathname;
  const routeUrl = `${SITE_URL}${path}`;
  if (title) {
    document.title = title;
    upsertMeta("property", "og:title", title);
    upsertMeta("name", "twitter:title", title);
  }
  if (description) {
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:description", description);
    upsertMeta("name", "twitter:description", description);
  }
  if (keywords) {
    upsertMeta("name", "keywords", keywords);
  }
  if (image) {
    const absolute = image.startsWith("http") ? image : `${SITE_URL}${image}`;
    upsertMeta("property", "og:image", absolute);
    upsertMeta("name", "twitter:image", absolute);
    upsertMeta("property", "og:image:width", "1200");
    upsertMeta("property", "og:image:height", "630");
  }
  upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
  upsertMeta("property", "og:url", routeUrl);
  upsertLink("canonical", routeUrl);
}

export function useSeo({ title, description, keywords, image, noindex }) {
  useEffect(() => {
    setPageMeta({ title, description, keywords, image, noindex });
  }, [title, description, keywords, image, noindex]);
}
